/* src/app/core/tabs/tabs.component.scss */
.tabs-container.vertical .tab {
  padding: 5px;
  text-align: center;
  cursor: pointer;
}
.tabs-container.vertical {
  width: 50px;
  height: 92vh;
}
.tabs-container.vertical .tab.active {
  color: var(--primaryColor);
  background-color: var(--menuSelectColor);
  font-weight: bold;
}
.tabs-container.vertical .nav {
  display: block;
}
.tabs-container.vertical ul {
  background: #fff;
  width: 50px;
  margin-right: 1px;
  float: left;
  height: 92vh;
}
.tabs-container.vertical li {
  margin: 10px 0px;
}
.tabs-container.vertical .tab-content {
  background: transparent;
  visibility: hidden;
  min-width: 360px;
}
.tabs-container.vertical .tab-content.active {
  visibility: visible;
}
.tabs-container.vertical .pane::-webkit-scrollbar {
  display: none;
}
.tabs-container.vertical > :has(.active) .tab-content {
  width: 100%;
}
.right-box-shadow {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
@media screen and (max-width: 640px) {
  .tabs-container.vertical .tab-content {
    background: transparent;
    visibility: visible;
    min-width: 360px;
  }
}
/*# sourceMappingURL=tabs.component.css.map */
